<template>
  <div class="heading-wrapper">
    <profile-picture
      class="profile-picture"
      v-if="showProfilePicture"
      :image="profilePicture"
    />
    <round-button-with-icon
      class="heading-icon"
      v-if="icon"
      :icon="icon"
      @click="iconClicked"
    />
    <div class="text-group">
      <h1 v-if="heading">{{ heading }}</h1>
      <h1 v-if="secondaryHeading">{{ secondaryHeading }}</h1>
      <h3 v-if="subheading">{{ subheading }}</h3>
      <h3 v-if="secondarySubheading">{{ secondarySubheading }}</h3>
    </div>
  </div>
</template>
<script>
import ProfilePicture from "./ListItems/ListItemComponents/ProfilePicture.vue";
import RoundButtonWithIcon from "./RoundButtonWithIcon.vue";

export default {
  methods: {
    iconClicked() {
      this.$emit("icon-clicked");
    },
  },
  components: {
    ProfilePicture,
    RoundButtonWithIcon,
  },
  emits: ["icon-clicked"],
  props: [
    "icon",
    "heading",
    "subheading",
    "secondary-heading",
    "secondary-subheading",
    "profile-picture",
    "show-profile-picture",
  ],
};
</script>
<style scoped>
@media screen {
  .heading-wrapper {
    display: flex;
    align-items: flex-start;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .profile-picture {
    margin-right: 15px;
  }

  .heading-icon {
    margin: 7px 15px;
  }
  h1 {
    font-family: Raleway, Helvetica, sans-serif;
    font-weight: 700;
    font-size: 1.25rem;
    letter-spacing: 0em;
    text-align: left;
    margin: 5px;
    margin-left: 0;
  }
  h3 {
    text-align: left;
    margin: 0;
    font-size: 1rem;
    font-weight: 400;
  }
  @media (max-width: 800px) {
    .profile-picture {
      margin-right: 15px;
    }

    .heading-icon {
      margin: 7px 15px;
    }
    h1 {
      font-family: Raleway, Helvetica, sans-serif;
      font-weight: 700;
      font-size: 1.25rem;
      letter-spacing: 0em;
      text-align: left;
      margin: 5px;
      margin-left: 0;
    }
    h3 {
      text-align: left;
      margin: 0;
      font-size: 1rem;
      font-weight: 400;
    }
  }
  @media (min-width: 800px) {
    .heading-wrapper {
      display: flex;
      align-items: flex-start;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .profile-picture {
      margin-right: 15px;
    }

    .heading-icon {
      margin: 7px 15px;
    }
    h1 {
      font-family: Raleway, Helvetica, sans-serif;
      font-weight: 700;
      font-size: 1.5em;
      letter-spacing: 0em;
      text-align: left;
      margin: 5px;
      margin-left: 0;
    }
    h3 {
      text-align: left;
      margin: 0;
      font-size: 1rem;
      font-weight: 400;
    }
  }
}
</style>
